import React, { useState } from 'react';
import CloseButton from './CloseButton';
import RefreshButton from './RefreshButton';
import ExportButton from './ExportButton';
import CardIcon from './CardIcon';
import { PlainButton } from './ButtonsV2';
import Label from './Label';
import CustomDatePicker from './CustomDatePicker/CustomDatePicker';
import { generateLabelsByTitle } from '../../utils/generateLabels';

const DataVisualizationContainer = ({
  title,
  iconType,
  onClose,
  onRefresh,
  onExport,
  exportOptions = [],
  selectedDate,
  onDateChange,
  onShowAllSessions,
  isShowAllActive,
  children,
  selectedUnit,
  hideExtraFilters,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleContainerClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const LABELS_BY_TITLE = generateLabelsByTitle();
  const { startDateLabel, showAllLabel } = LABELS_BY_TITLE[title] || LABELS_BY_TITLE['Default'];

  return (
    <div
      className={`fixed inset-0 w-full h-screen bg-[#F2F6FA] text-black md:px-12 lg:py-8 lg:px-20 px-4 py-4 flex flex-col overflow-y-auto ${
        isClosing ? 'animate-slide-out' : 'animate-slide-in'
      }`}
    >
      {/* Header */}
      {!hideExtraFilters && (
        <>
          <div className="relative flex items-center justify-between pt-[80px] pb-4 mb-2">
            <div className="absolute top-0 right-0">
              <CloseButton onClick={handleContainerClose} />
            </div>
            {/* Centered unit name */}
            <div className="absolute top-[15px] left-1/2 transform -translate-x-1/2">
              <h2 className="text-center text-2xl lg:text-3xl  font-semibold">
                {selectedUnit?.data_unit_name}
              </h2>
            </div>
            <div className="flex space-x-6 items-center">
              <CardIcon type={iconType} variant="secondary" />
              <h1 className="text-lg md:text-2xl font-semibold">{title}</h1>
            </div>
            <div className="flex items-center space-x-8 max-lg:flex-col max-lg:items-end max-lg:space-x-0 max-lg:space-y-4">
              <div className="flex items-center space-x-4">
                <ExportButton exportOptions={exportOptions} onExport={onExport} />
                <RefreshButton onClick={onRefresh} />
              </div>
            </div>
          </div>
          <div className="relative flex items-center justify-between pt-[20px] pb-4 mb-2">
            <div className="flex md:items-center justify-end md:space-x-4 max-md:flex-col max-md:space-y-4 min-w-0 w-full whitespace-nowrap">
              <Label>{startDateLabel}:</Label>
              <CustomDatePicker
                onDateChange={onDateChange}
                isClearable={!selectedDate}
                placeholderText="Select a start date"
                defaultDate={selectedDate}
              />
              <PlainButton
                variant="light"
                customClass="mt-[0px]"
                onClick={onShowAllSessions}
                disabled={isShowAllActive}
              >
                {showAllLabel}
              </PlainButton>
              {/** filterComponent */}
            </div>
          </div>
        </>
      )}

      {/* Content */}
      <div className="flex-grow flex flex-col">{children}</div>
    </div>
  );
};

export default DataVisualizationContainer;
